import {Box} from "@mui/material";

export default function PageOuterContainer({children}) {

    return (
        <Box display={"flex"} flexDirection={"column"} width={"100%"} alignItems={"center"}>
            {children}
        </Box>
    )
}
